import React from 'react';
import logoWhite from '../assets/core-logo-white.png';

/**
 * Core Estimating logo (white "CORE" / orange "ESTIMATING").
 * Height is controlled via className (e.g. "h-9").
 */
const Logo = ({ className = 'h-9' }) => {
  return (
    <img
      src={logoWhite}
      alt="Core Estimating"
      className={`w-auto ${className}`}
    />
  );
};

export default Logo;
